module.exports = __webpack_public_path__ + "static/fonts/remixicon.881fbc46.881fbc46.woff";